import * as Mod1 from "./discourse/discourse-workflows-public-route-map";
import * as Mod2 from "./discourse/initializers/admin-plugin-configuration-nav";
import * as Mod3 from "./discourse/initializers/assistant-workflow-preview";
import * as Mod4 from "./discourse/initializers/post-button-workflows";
import * as Mod5 from "./discourse/initializers/topic-admin-button-workflows";
import * as Mod6 from "./discourse/initializers/workflow-webhook-links";
import * as Mod7 from "./discourse/initializers/workflows-composer-message";
import * as Mod8 from "./discourse/initializers/workflows-composer-paused";
import * as Mod9 from "./discourse/initializers/workflows-user-modal";
import * as Mod10 from "./discourse/pre-initializers/workflow-transformers";
import * as Mod11 from "./discourse/services/workflows-composer-paused";
import * as Mod12 from "./discourse/services/workflows-composer-session";
import * as Mod13 from "./discourse/services/workflows-node-types";
const compatModules = {
  "discourse/discourse-workflows-public-route-map": Mod1,
  "discourse/initializers/admin-plugin-configuration-nav": Mod2,
  "discourse/initializers/assistant-workflow-preview": Mod3,
  "discourse/initializers/post-button-workflows": Mod4,
  "discourse/initializers/topic-admin-button-workflows": Mod5,
  "discourse/initializers/workflow-webhook-links": Mod6,
  "discourse/initializers/workflows-composer-message": Mod7,
  "discourse/initializers/workflows-composer-paused": Mod8,
  "discourse/initializers/workflows-user-modal": Mod9,
  "discourse/pre-initializers/workflow-transformers": Mod10,
  "discourse/services/workflows-composer-paused": Mod11,
  "discourse/services/workflows-composer-session": Mod12,
  "discourse/services/workflows-node-types": Mod13,
};
const pluginExports = {
};
export const routes = [
  { names: ["workflows-form","workflows-form-test"], load: () => import("virtual:route:main:workflows-form") },
];
export { compatModules };
export default pluginExports;
